import { useMemo } from 'react';
import { computeCutoffState } from '../core/rules/cutoffState';
import { useServerClock } from './useServerClock';

import type { HouseConfig } from '../types';

export function useCutoffTimer(config: HouseConfig | Record<string, unknown> | null | undefined) {
  const { now } = useServerClock();

  return useMemo(() => computeCutoffState(now, config), [now, config]);
}
